import { MessagingMessage_ReadCount_Read } from '@treadinc/horizon-api-spec';

type MessagingReadEvent = {
  action: 'read';
  data: { messaging_channel_id: string; read_counts: MessagingMessage_ReadCount_Read[] };
};

const isReadCount = (entry: unknown): entry is MessagingMessage_ReadCount_Read => {
  if (!entry || typeof entry !== 'object') return false;

  const { message_id, read_count } = entry as Partial<MessagingMessage_ReadCount_Read>;

  return typeof message_id === 'string' && typeof read_count === 'number';
};

export const asReadEvent = (payload: unknown): MessagingReadEvent | undefined => {
  if (!payload || typeof payload !== 'object') return undefined;

  const { data, action } = payload as Partial<MessagingReadEvent>;
  if (action !== 'read') return undefined;
  if (
    !data ||
    typeof data.messaging_channel_id !== 'string' ||
    !Array.isArray(data.read_counts) ||
    !data.read_counts.every(isReadCount)
  ) {
    return undefined;
  }

  return payload as MessagingReadEvent;
};
